module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Vorgeschlagene Beträge","track":"Suggested amounts"}}